import css from './index.module.scss';
import { useGlobal } from '@/utils/useGlobal';
import EFVideoReplayH5 from '@/components/UI/svg/Icons/EFVideoReplayH5';
import { EFVideoPlayer, EFKitH1SvgH5, EFKitH2SvgH5, EFKitH3SvgH5 } from '@/components/UI/svg/mm100';
import EFVideo from '@/components/UI/EFVideo';
import EFVideoModal from '@/components/UI/EFVideoModal';

export default function Comp({ type = 'rv', customClass }: any) {
    const { useLang, useEffect, useState, gtm, useRouter, useRef } = useGlobal();
    const { locale } = useRouter();
    const { t } = useLang('ecoflowpowerkitsseries');
    const [videoEnterA, setVideoEnterA] = useState(false);
    let controller: any;
    const videoRef1 = useRef(null);
    const videoRef2 = useRef(null);
    const [showEFVideoModal, setShowEFVideoModal] = useState(false);

    const videoSourceMap = {
        us: 'https://www.youtube.com/embed/jLs7VZlu-9A',
        jp: 'https://www.youtube.com/embed/Npk28ID2tI0',
        cn: {
            SD: 'https://videos.ecoflow.com/f16cc2ab3caa456a832c8bca6925bb05/17e3d1f6aee94b749529013a52f43245-9a4860f4b352b4834e2ec21cbbd5bd27-fd.mp4',
            HD: 'https://videos.ecoflow.com/f16cc2ab3caa456a832c8bca6925bb05/17e3d1f6aee94b749529013a52f43245-7852f6b282043467f020800dc0a94e65-sd.mp4',
            '2K': 'https://videos.ecoflow.com/original/workflow/15a4409a-1842c2aadfc-0004-9c91-e6d-40030.mp4',
        },
    };

    const svgList = [
        {
            svg: <EFKitH1SvgH5 width="0.55rem" height="0.42rem" />,
            text: t('presale.product.kitH_svg_dec1'),
        },
        {
            svg: <EFKitH2SvgH5 width="0.55rem" height="0.43rem" />,
            text: t('presale.product.kitH_svg_dec2'),
        },
        {
            svg: <EFKitH3SvgH5 width="0.55rem" height="0.42rem" />,
            text: t('presale.product.kitH_svg_dec3'),
        },
    ];
    const playerVideo = () => {
        gtm.push({
            event: 'uaEvent',
            event_name: 'video',
            title_name: 'EcoFlow Power Kits - Compact and Integrated Power Solution',
            position: 'Product_3',
        });
        setShowEFVideoModal(true);
    };

    useEffect(() => {
        controller = new ScrollMagic.Controller();
    }, []);

    useEffect(() => {
        const sceneA1 = new ScrollMagic.Scene({
            triggerElement: `.kitH .kit-video`,
            offset: 0, //从开始点滚动多少px触发,可为负数
            triggerHook: 1.2, //触发元素开始进入视口时触发:1 进入,0 离开, 0.5 中间,
            duration: '400%', //和滚动条绑定到一起,场景持续滚动距离为 800px
        });

        sceneA1.on('enter', function () {
            setVideoEnterA(true);
        });
        sceneA1.on('leave', function () {
            setVideoEnterA(false);
        });

        controller.addScene(sceneA1);
    }, []);

    return (
        <div className={`${css.kitH} kitH ${customClass}`}>
            <div className="kit-inter">
                <div className="kit-text">
                    <div className="kit-ms1">{t('presale.product.kitH_ms1')}</div>
                    <div className="kit-ms2">{t('presale.product.kitH_ms2')}</div>
                    <div className="kit-ms3">
                        {type === 'rv'
                            ? t(locale === 'kr' ? 'presale.product.kitH_ms3_rv_h5' : 'presale.product.kitH_ms3_rv')
                            : t(locale === 'kr' ? 'presale.product.kitH_ms3_off_grid_h5' : 'presale.product.kitH_ms3_off_grid')}
                    </div>
                    <div className="watch-video-btn" onClick={playerVideo}>
                        {t('presale.product.watch_video')}
                        <EFVideoPlayer className="icon" color="#2673ff" />
                    </div>
                    <div className="svg-box" style={{ display: locale === 'us' ? 'flex' : 'none' }}>
                        {svgList.map((item, index) => (
                            <div key={index} className="row-item">
                                <div className="svg-item">{item.svg}</div>
                                <div className="text-item" style={{ width: item.textWidth }}>
                                    {item.text}
                                </div>
                            </div>
                        ))}
                    </div>
                </div>
                <div className="kit-video">
                    <div className="kit-box kit-box1">
                        {videoEnterA && (
                            <EFVideo
                                ref={videoRef1}
                                sources={['/video/mm100m/kitH_h5_1.webm', '/video/mm100/kitH_h5_1.mp4']}
                                className="video kitH_video1"
                                loop={false}
                            />
                        )}
                        <span className="btn-video-play" onClick={() => videoRef1.current?.play()}>
                            <EFVideoReplayH5 />
                        </span>
                        <span className="kit-video-tips">{t('presale.product.kitH_box1_tips')}</span>
                    </div>
                    <div className="kit-box kit-box2">
                        {videoEnterA && (
                            <EFVideo
                                ref={videoRef2}
                                sources={['/video/mm100m/kitH_h5_2.webm', '/video/mm100/kitH_h5_2.mp4']}
                                className="video kitH_video2"
                                loop={false}
                            />
                        )}
                        <span className="btn-video-play" onClick={() => videoRef2.current?.play()}>
                            <EFVideoReplayH5 />
                        </span>
                        <span className="kit-video-tips">{t('presale.product.kitH_box2_tips')}</span>
                    </div>
                </div>
            </div>
            <EFVideoModal
                visible={showEFVideoModal}
                source={videoSourceMap[locale] || videoSourceMap.us}
                onClose={() => setShowEFVideoModal(false)}
                playerType={locale === 'cn' ? 'Alibaba' : 'YouTube'}
            />
        </div>
    );
}
